import { render, staticRenderFns } from "./UploadTopImg.vue?vue&type=template&id=3f6c361f&scoped=true&ref=uploadImage"
import script from "./UploadTopImg.vue?vue&type=script&lang=js"
export * from "./UploadTopImg.vue?vue&type=script&lang=js"
import style0 from "./UploadTopImg.vue?vue&type=style&index=0&id=3f6c361f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c361f",
  null
  
)

export default component.exports